export default __webpack_public_path__ + "static/log-management-fundamentals-4038f7d60b7d64497e61f5b3a0319ae0.png";